var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.04 8.16675C15.04 7.64675 14.9933 7.14675 14.9067 6.66675H8V9.50675H11.9467C11.7733 10.4201 11.2533 11.1934 10.4733 11.7134V13.5601H12.8533C14.24 12.2801 15.04 10.4001 15.04 8.16675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.04 8.16675C15.04 7.64675 14.9933 7.14675 14.9067 6.66675H8V9.50675H11.9467C11.7733 10.4201 11.2533 11.1934 10.4733 11.7134V13.5601H12.8533C14.24 12.2801 15.04 10.4001 15.04 8.16675Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.3332C9.98003 15.3332 11.64 14.6799 12.8534 13.5599L10.4734 11.7132C9.82003 12.1532 8.9867 12.4199 8.00004 12.4199C6.09337 12.4199 4.47337 11.1332 3.89337 9.3999H1.45337V11.2932C2.66004 13.6866 5.13337 15.3332 8.00004 15.3332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.3332C9.98003 15.3332 11.64 14.6799 12.8534 13.5599L10.4734 11.7132C9.82003 12.1532 8.9867 12.4199 8.00004 12.4199C6.09337 12.4199 4.47337 11.1332 3.89337 9.3999H1.45337V11.2932C2.66004 13.6866 5.13337 15.3332 8.00004 15.3332Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89329 9.39338C3.74663 8.95338 3.65996 8.48671 3.65996 8.00005C3.65996 7.51338 3.74663 7.04671 3.89329 6.60671V4.71338H1.45329C0.953293 5.70005 0.666626 6.81338 0.666626 8.00005C0.666626 9.18671 0.953293 10.3 1.45329 11.2867L3.35329 9.80671L3.89329 9.39338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89329 9.39338C3.74663 8.95338 3.65996 8.48671 3.65996 8.00005C3.65996 7.51338 3.74663 7.04671 3.89329 6.60671V4.71338H1.45329C0.953293 5.70005 0.666626 6.81338 0.666626 8.00005C0.666626 9.18671 0.953293 10.3 1.45329 11.2867L3.35329 9.80671L3.89329 9.39338Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 3.58675C9.08004 3.58675 10.04 3.96008 10.8067 4.68008L12.9067 2.58008C11.6334 1.39341 9.98004 0.666748 8.00004 0.666748C5.13337 0.666748 2.66004 2.31341 1.45337 4.71342L3.89337 6.60675C4.47337 4.87341 6.09337 3.58675 8.00004 3.58675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 3.58675C9.08004 3.58675 10.04 3.96008 10.8067 4.68008L12.9067 2.58008C11.6334 1.39341 9.98004 0.666748 8.00004 0.666748C5.13337 0.666748 2.66004 2.31341 1.45337 4.71342L3.89337 6.60675C4.47337 4.87341 6.09337 3.58675 8.00004 3.58675Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.svg";
export { ForwardRef as ReactComponent };